import React from "react";
import ContentCard from "../../../../UI/ContentCard/ContentCard";

import prod1Img from "../../../../assests/images/prod1.png";
import prod2Img from "../../../../assests/images/prod2.png";
import prod3Img from "../../../../assests/images/prod3.png";
import prod4Img from "../../../../assests/images/prod4.png";

const Production = () => (
  <ContentCard
    title="THE PRODUCTION PLACE"
    id="production"
    image={prod3Img}
    imageTtitle="Our Production Place"
    frontText="We looked at a lot of places where we could start our production of a hoodie."
    backTextOne="We looked at a lot of places where we could start our production of a hoodie. The most popular places in the textile industry are countries
          in Asia like China, India or Bangladesh. But for us a lot of factories in these countries are questionable in terms of production circumstances,
          loans, safety and health. For us the perfect product is not only about materials and craftsmanship, it is also about the development process. So our
          plan was to find a spot where we could realize a 100 % transparent production cycle with a reasonable environment for workers. This is why we finally
          decided to place our production in Mauritius. For decades this country has a long history in the textile industry. Even though this business sector is
          decreasing, there is a very professional infrastructure and knowledge in this field. To move from one side of the island to the other you will need at
          most two hours. This means that everything is reachable in a small amount of time. After knocking at a lot of doors we finally found places where we can
          produce and dye our fabrics, sew our garments, print unique designs and add embroidery on our products. The most important fact is that we can control, videotape
          and supervise every single step of production. Every one of our products will have a bar code. The customer can scan the code and can easily access information  about where, when and
          by whom the products were produced. We want to achieve a 100 % controlled production chain. For us this means we are on the spot directly in
          the factories when our products are produced. At the moment we are achieving about 95 % of this goal.  This is due to the fact that there is
          no factory in Mauritius which is producing some of the needed accessories such as zippers, zipper stoppers and aglets. For these accessories we chose
          factories that provide certificates for the Öko-Tex 100 Standard or the Global Organic Textile Standard (GOTS)."
    imageBack1={prod1Img}
    imageTitle1="dying house"
    imageBack2={prod2Img}
    imageTitle2="factory"
    imageBack3={prod4Img}
    imageTitle3="factory"
    caption="We knocked at the doors of over 30 factories to find the right spot for our production.
                Just to give an impression what we saw on our tour, you see  three different Mauritian sewing factories.
                The picture above shows a dying house where fabrics are dyed in this huge metal vessel."
  />
);

export default Production;



// WEBPACK FOOTER //
// ./src/components/Pages/Progress/Content/TheProductionPlace.js